import React from "react";
import Navbar from "../../Components/Navbar";
import Home from "./Home";
function Main() {
  return (
    <>
      <Navbar />
      <Home />
    </>
  );
}

export default Main;
